import { supabase } from "@/integrations/supabase/client";
import { isFramed } from "@/lib/framed";

export function trackEvent(name: string, params: Record<string, string | number | boolean | undefined>) {
  if (isFramed()) return;
  try {
    window.gtag?.("event", name, params);
  } catch {
    // Tracking must never interrupt the visitor.
  }
}

export function trackInternalEvent(eventType: string, label?: string): void {
  if (isFramed()) return;
  try {
    void Promise.resolve(
      supabase.functions.invoke("track-analytics", {
        body: {
          event_type: eventType,
          page_path: window.location.pathname,
          button_label: label ?? "",
          referrer: document.referrer || "",
        },
      }),
    ).catch(() => undefined);
  } catch {
    // Tracking must never interrupt the visitor.
  }
}
